import DashEvents from 'screens/dashboard/DashEvents';
import paths from './paths';
import DashProfile from 'screens/dashboard/DashProfile';
import DashSupport from 'screens/dashboard/DashSupport';
import DashFinancial from 'screens/dashboard/DashFinancial';
import DashCheckin from 'screens/dashboard/DashCheckin';
import DashProducts from 'screens/dashboard/DashProducts';
import DashOrders from 'screens/dashboard/DashOrders';
import DashEstablishmentOrders from 'screens/dashboard/DashEstablishmentOrders';
import DashStatistics from 'screens/dashboard/DashStatistics';
import DashRestaurantMenu from 'screens/dashboard/DashRestaurantMenu';
import DashRestaurantKitchen from 'screens/dashboard/DashRestaurantKitchen';
import DashRestaurantWaiter from 'screens/dashboard/DashRestaurantWaiter';
import DashRestaurantAdmin from 'screens/dashboard/DashRestaurantAdmin';
import DashRestaurantStatistics from 'screens/dashboard/DashRestaurantStatistics';
import DashRestaurantCashier from 'screens/dashboard/DashRestaurantCashier';
import DashRestaurantCashierSession from 'screens/dashboard/DashRestaurantCashierSession';
import DashRestaurantPosEvents from 'screens/dashboard/DashRestaurantPosEvents';
import DashRestaurantCustomers from 'screens/dashboard/DashRestaurantCustomers';
import DashRestaurantPromotions from 'screens/dashboard/DashRestaurantPromotions';
import DashRestaurantInventory from 'screens/dashboard/DashRestaurantInventory';
import DashAffiliate from 'screens/dashboard/DashAffiliate';
import DashProducerCustomers from 'screens/dashboard/DashProducerCustomers';
import { PRODUCER_ROLES, ESTABLISHMENT_ROLES } from 'helpers/dashboardAccess';

export default [
    // {
    //     exact: true,
    //     path: paths.dashboard.resume,
    //     element: <DashResume />
    // },
    {
        exact: true,
        path: paths.dashboard.events,
        element: <DashEvents />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.products,
        element: <DashProducts />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.home,
        element: <DashProfile />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.financial,
        element: <DashFinancial />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.checkin,
        element: <DashCheckin />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.support,
        element: <DashSupport />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.orders,
        element: <DashOrders />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.orders_establishment,
        element: <DashEstablishmentOrders />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.statistics,
        element: <DashStatistics />,
        roles: PRODUCER_ROLES
        // element: <DashResume />
    },
    {
        exact: true,
        path: paths.dashboard.affiliate,
        element: <DashAffiliate />,
        roles: PRODUCER_ROLES
    },
    {
        exact: true,
        path: paths.dashboard.customers,
        element: <DashProducerCustomers />,
        roles: PRODUCER_ROLES
    },
    { exact: true, path: paths.dashboard.establishment.profile,    element: <DashProfile />,              roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.menu,       element: <DashRestaurantMenu />,       roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.posEvents,  element: <DashRestaurantPosEvents />,  roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.kitchen,    element: <DashRestaurantKitchen />,    roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.waiter,     element: <DashRestaurantWaiter />,     roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.admin,      element: <DashRestaurantAdmin />,      roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.statistics, element: <DashRestaurantStatistics />, roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.cashier,    element: <DashRestaurantCashier />,    roles: ESTABLISHMENT_ROLES },
    { exact: true, path: `${paths.dashboard.establishment.cashier}/:sessionId`, element: <DashRestaurantCashierSession />, roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.customers,  element: <DashRestaurantCustomers />,  roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.promotions, element: <DashRestaurantPromotions />, roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.inventory,  element: <DashRestaurantInventory />,  roles: ESTABLISHMENT_ROLES },
    { exact: true, path: paths.dashboard.establishment.affiliate,  element: <DashAffiliate />,             roles: ESTABLISHMENT_ROLES },
]